export abstract class KioskTypes {

    public static BoatLaunch = "BoatLaunch";
    public static DayUse = "DayUse";
    public static DumpStation = "DumpStation";
    public static HeadedKiosk = "HeadedKiosk";

}


